import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'comparison',
    label: 'Comparison Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
